import { render, staticRenderFns } from "./ProfileWaiting.vue?vue&type=template&id=e8b8538e&"
import script from "./ProfileWaiting.vue?vue&type=script&lang=js&"
export * from "./ProfileWaiting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports